<template>
    <div class="LogicSettingsItem2">
        <div class="box">
            <div style="width: 100%"  v-for="(conditionItem, index) in showLogicalSettings" :key="index">
                <template v-if="conditionItem">
                    
                <div class="disconditions">
                    <div>
                        <span>{{$t('main.MeetTheFollowingRequirements')}}</span>
                        <el-select size="small" v-model="conditionItem.condition" :placeholder="$t('main.whole')" value-key="value" style="margin: 0 10px">
                            <el-option v-for="item in conditionList" :key="item.value" :label="item.labelName" :value="item.value"></el-option>
                        </el-select>
                        <span>{{$t('main.ShowThisIssueWhenConditionsAreMet')}}</span>
                    </div>
                    <i class="el-icon-delete" @click="delCondition(index)"></i> 
                </div>
                <el-button size="small" style="margin-top: 10px;" v-if="conditionItem.conditionList && conditionItem.conditionList.length == 0" @click="adddom(conditionItem.conditionList.length-1, index)">{{$t('main.DisplayLogic')}}</el-button>
                
                <div v-else class="showLogicalSettings">
                    <div>
                    <div class="show-box" v-for="(item, i) in conditionItem.conditionList" :key="i">
                        <!-- 请选择题目 -->
                        <div class="choiceQuestion">
                            <el-select size="small" v-model="item.questionId" :placeholder="$t('main.PleaseSelectAQuestion')" value-key="questionId" @change="titleDome($event, item, i, index)">
                                <el-option
                                    v-for="info in currentQuestionUpAllQuestions"
                                    :key="info.qid"
                                    :label="
                                        info.questionIndex
                                            ? 'Q' + info.questionIndex + ' ' + $functions.htmlFormat(info.questionsName)
                                            : $functions.htmlFormat(info.questionsName)
                                    "
                                    :value="info.qid"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="labelClass show-type" style=" margin-left: 15px; margin-right: 15px">
                            <el-select size="small" v-model="item.questionState" :placeholder="$t('main.PleaseSelectACondition')" value-key="questionId">
                                <el-option v-for="item in showLogicCondition" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                        
                        <!-- 选项  -->
                        <div class="labelClass"
                            v-if="amswerOptionTypeList.indexOf(item.typeId) !== -1"
                            v-show="item.questionState != 3 && item.questionState != 4"
                        >
                            <el-select size="small" v-model="item.optionId" :placeholder="$t('main.PleaseSelectAnOption')" value-key="id">
                                <el-option v-for="el in item.showOptionList" :key="el.oid" :label="$functions.htmlFormat(el.labelName)" :value="el.oid">
                                    {{ $functions.htmlFormat(el.labelName) }}
                                </el-option>
                                <el-option :label="$t('main.AnyOption')" :value="0"></el-option>
                            </el-select>
                        </div>
                        
                        <!-- 大小选项 -->
                        <el-select 
                            v-if="amswerNumTypeList.indexOf(item.typeId) !== -1 &&
                            (item.questionState != 3 || item.questionState == 4)"
                            size="small" 
                            v-model="item.startNum" 
                            :placeholder="$t('main.StartingScore')"
                            class="start-Num"
                        >
                            <el-option 
                                v-for="(info, index) in item.orderSetting" 
                                :key="index" 
                                :label="item.activeStartNum + index"
                                :value="item.activeStartNum + index"
                            >{{item.activeStartNum + index}}</el-option>
                        </el-select>
                        <!-- 结束分数 -->
                        <el-select 
                            v-if="amswerNumTypeList.indexOf(item.typeId) !== -1 && 
                            item.questionState == 8"
                            size="small" 
                            v-model="item.endNum" 
                            :placeholder="$t('main.EndScoreScore')"
                            class="max-Num"
                        >
                            <el-option 
                                v-for="(info, index) in item.orderSetting - item.startNum -1" 
                                :key="index" 
                                :label="item.activeStartNum + index + item.startNum + 1"
                                :value="item.activeStartNum + index + item.startNum + 1"
                            >{{item.activeStartNum + index + item.startNum + 1}}</el-option>
                        </el-select>
                        <div class="icon_num" >
                            <i class="icon iconfont iconjian" @click="removeDom(item, index)"></i>
                            <i class="icon iconfont iconjia" @click="adddom(i, index)"></i>
                        </div>
                    </div>
                    </div>
                </div>
                </template>
            </div>
        </div>
        <el-button v-if="showLogicalSettings.length == 0" class="addbtn" size="small" @click="addShowClick">{{$t('main.AddDisplayLogic')}}</el-button>
    </div>
</template>

<script>
export default {
    // 逻辑设置 - 显示逻辑 - 满足以下条件显示该题，满足多个条件，显示当前试题
    name: 'LogicSettingsItem2', 
    props: {
        questionsList: {
            type: Array,
            default: () => []
        },
        showLogicalSettings: {
            type: Array,
            default: () => []
        },
        activeQuestion: {
            type: Object,
            default: () => {}
        },
        currentQuestionUpAllQuestions: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
			showLogicCondition: [
				{
					label: this.$t('main.Selected'),
					value: 1
				},
				{
					label: this.$t('main.notSelected'),
					value: 2
				},
				{
					label: this.$t('main.show'),
					value: 3
				},
				{
					label: this.$t('main.NoShow'),
					value: 4
				}
			],
			amswerNumTypeList: ['38'], // 选择数字范围类型
			amswerOptionTypeList: ['6', '8', '9', '10', '12',], // 选择选项类型
            // conditionListBox: [],
            conditionList: [ // 绑定该题的显示条件
				{
					labelName: this.$t('main.whole'),
					value: 1
				},
				{
					labelName: this.$t('main.Arbitrarily'),
					value: 2
				}
            ],
            // arrBox: [], 
            // andOrList: [
			// 	{
			// 		labelName: '且',
			// 		value: 1
			// 	},
			// 	{
			// 		labelName: '或',
			// 		value: 2
			// 	}
			// ],
            // isShowQuesList: [],
            showTypeList: ['6','8', '10', '12', '19']
        }
    },
    created() {
        this.showLogicInit()
    },
    methods:{
        // 初始化条件
        showLogicInit() {
			let quesTypeArr = ['6', '8', '9', '10', '12', '19','38'];
            // console.log('this.showLogicalSettings :>> ', this.showLogicalSettings);
            this.showLogicalSettings.forEach((item, showIndex) => {
                if (!item) return
                // console.log('item.conditionList :>> ', item.conditionList);
				item.conditionList.forEach((info,index) => {
					for (let i = 0; i < this.questionsList.length; i++) {
                        // console.log('i :>> ', i);
						let { qid, questionsTypeId, startNum } = this.questionsList[i]
						if (info.questionId == qid && quesTypeArr.indexOf(questionsTypeId) !== -1) {
							info.typeId = questionsTypeId
							if(questionsTypeId == '38') {
								info.activeStartNum = startNum
							}
						
							this.titleDome(info.questionId, info, index, showIndex)
							this.$set(info, 'showOptionList', this.questionsList[i].optionList);
							// console.log(info)
						}
					}
				});
			})
        },
		// 增加显示逻辑
		adddom(i, index) {
                let obj = {
                    questionId: '', // 题目
                    questionState: 1, // 题目状态
                    optionId: 0, // 状态条件（题目状态是选中时）
                    startNum: '', // 起始分数 如果不是'介于' 默认使用起始分数
                    endNum: '', // 结束分数
                }
			if (i != 'undefined') {
				this.showLogicalSettings[index].conditionList.splice(i + 1, 0, obj);
			} else {
				this.showLogicalSettings[index].conditionList.push(obj);
			}
        },
        
        // 选择题目
		titleDome(questionid, item, index, showIndex) {
			// console.log(item);
            let { conditionList } = this.showLogicalSettings[showIndex]
			this.currentQuestionUpAllQuestions.forEach(info => {
				if (info.qid == questionid) {
					conditionList[index].showOptionList = [...info.optionList]
					conditionList[index].typeId = info.questionsTypeId
					conditionList[index].orderSetting = info.orderSetting
					conditionList[index].activeStartNum = info.startNum
					if (
						info.questionsTypeId != '6' &&
						info.questionsTypeId != '8' &&
						info.questionsTypeId != '10' &&
						info.questionsTypeId != '12' &&
						info.questionsTypeId != '19' &&
						info.questionsTypeId != '38'
					) {
						this.showLogicCondition = [
							{
								label: this.$t('main.show'),
								value: 3
							},
							{
								label: this.$t('main.NoShow'),
								value: 4
							}
						];
						item.questionState = 3;
					} else if (info.questionsTypeId == '38') {
						this.showLogicCondition =  [
							{
								value: 5,
								label: this.$t('main.EqualTo')
							},
							{
								value: 6,
								label: this.$t('main.GreaterThan')
							},
							{
								value: 7,
								label: this.$t('main.LessThan')
							},
							{
								value: 8,
								label: this.$t('main.Betweenness')
							},{
								label: this.$t('main.show'),
								value: 3
							},
							{
								label: this.$t('main.NoShow'),
								value: 4
							}
						]
					} else {
						this.showLogicCondition = [
							{
								label: this.$t('main.Selected'),
								value: 1
							},
							{
								label: this.$t('main.notSelected'),
								value: 2
							},
							{
								label: this.$t('main.show'),
								value: 3
							},
							{
								label: this.$t('main.NoShow'),
								value: 4
							}
						];
						item.questionState = 1;
					}
				}
			});
		},
		removeDom(item, index) {
			// console.log(item);
			var i = this.showLogicalSettings[index].conditionList.indexOf(item);
			// console.log(index)
			if (i !== -1) {
				// this.clearQuestionId(index)
				this.showLogicalSettings[index].conditionList.splice(i, 1);
				// if (conditionList[index].questionId)
			}
		},
        // 删除条件
        delCondition(index) {
            this.showLogicalSettings.splice(index, 1);
        },
        addShowClick() {
            this.showLogicalSettings.push({
                condition: 1,
                conditionList: [this.setShowLogicalObj()],
            })
        },
        setShowLogicalObj(){
            let showLogicalObj = {
				questionId: '', // 题目
				questionState: 1, // 题目状态
				optionId: 0, // 状态条件（题目状态是选中时）
				startNum: '', // 起始分数 如果不是'介于' 默认使用起始分数
				endNum: '', // 结束分数
                typeId: this.activeQuestion.questionsTypeId
			}
            if (this.showTypeList.indexOf(this.activeQuestion.questionsTypeId) !== -1) {
                showLogicalObj.questionState = 3
            } else if(this.activeQuestion.questionsTypeId == '38') {
                showLogicalObj.questionState = 5
				showLogicalObj.orderSetting = this.activeQuestion.orderSetting
				showLogicalObj.activeStartNum = this.activeQuestion.startNum
            } else {
                showLogicalObj.questionState = 1
            }
            return showLogicalObj
        },
    }
}
</script>


<style scoped lang="scss">
.LogicSettingsItem2{
    margin-top: 16px;
    .showLogicalSettings{
		display: flex;
		align-items: center;
        justify-content: space-between;
    }
	.show-box{
		display: flex;
		align-items: center;
	}
	.show-box+.show-box,
    .showLogicalSettings+.showLogicalSettings{
		margin-top: 10px;
	}
	.icon{
		cursor: pointer;
	}
    .el-icon-delete{
        cursor: pointer;
        font-size: 20px;
        color: #ccc;
        margin-right: 30px;
    }
    .box{
        margin-bottom: 22px;
    }
    .disconditions{
		display: flex;
		align-items: center;
        justify-content: space-between;
        margin-bottom: 22px;
    }
}
</style>